import { Http } from '@services/http/http.service';

export interface NotificationsState {
  documents: { errors?: { count?: number } };
}

const path = '/notifications';

export async function getNotifications(): Promise<NotificationsState> {
  return await Http.getInstance().get({ path });
}
